// theme.js
import { createTheme } from '@mui/material';

const theme = createTheme({
  typography: {
    h1: {
        fontSize: '2.50em',
        fontWeight: '400',
        letterSpacing: '0em'
    },
  },
});

export default theme;
